import { createTracker } from 'usage-tracker';
import { getAuth } from 'quartz-auth/hubless/service';
import enviro from 'enviro';
const tracker = createTracker({
  standalone: true,
  allowUnauthed: true,
  debug: enviro.isQa()
});
export function setupUsageTracker() {
  const userInfo = getAuth();
  const email = userInfo.user.emails[0];
  tracker.setProperties({
    hubId: null,
    email
  });
}
export function trackDdgUsageEvents(properties) {
  tracker.track('Partner Demo Portal', 'Ddg Usage Events', properties);
}